import { createToolCallingAgent } from "langchain/agents"
import { ChatPromptTemplate } from "@langchain/core/prompts"
import { StructuredTool } from "langchain/tools"
import { ChatOpenAI } from "@langchain/openai"
import { AgentExecutor } from "langchain/agents"
import { SystemMessage } from "@langchain/core/messages"

import { store } from "index"

import z from 'zod'

import { saveItem, createTask, updateTask } from 'state/actions'
import { nl2br } from "./text"
import { removeSoftDeleted } from "./utils"

let agent = null

const llm = new ChatOpenAI({
	modelName: 'gpt-4o-mini',
	temperature: 0.7,
    apiKey: `sk-proj-Ed0LbGeSyt06MIbiJGrXT3BlbkFJ57fEw5vgmfYjS5cUZAOQ`,
    dangerouslyAllowBrowser: true
})

function runCreateTasksAndMilestones(projectId, milestones) {
    const { dispatch, getState } = store

    const state = getState()

    if (milestones?.length) {
        milestones.forEach(milestone => {
            const existingMilestone = state.account.entities.milestones[milestone.id]

            const callback = newMilestone => {
                milestone.tasks?.forEach(task => {
                    if (task.id) {
                        const existingTask = state.account.entities.tasks[task.id]

                        if (existingTask) {
                            dispatch(updateTask({
                                ...existingTask,
                                ...task,
                                milestone_id: newMilestone.id
                            }, _ => {

                            }))
                        }
                    } else {
                        dispatch(createTask(task.name, newMilestone.id, _ => {

                        }))
                    }
                })
            }

            if (existingMilestone) {
                callback(state.account.entities.milestones[milestone.id])
            } else {
                dispatch(saveItem({
                    name: milestone.name,
                    id: null,
                    project_id: projectId,
                    operation: 'add'
                }, 'milestone', callback))
            }
        })
    }

    console.log('BOY HE DID IT')
    console.log(projectId)
    console.log(milestones)
}

class CreateTasksAndMilestonesTool extends StructuredTool {
    schema = z.object({
        projectId: z.number().describe("The ID of the project"),
        milestones: z.array(z.object({
            id: z.number().optional().describe("The ID of the milestone (leave null to create a new one)"),
            name: z.string().describe("The name of the milestone (Can be an existing one)"),
            tasks: z.array(z.object({
                id: z.number().optional().describe("The ID of the task (leave null to create a new one)"),
                name: z.string().describe("The name of the task"),
            })).optional().describe("The tasks to create within the milestone")
        }))
    })

    name = "create_tasks_and_milestones"

    description = "Create tasks and/or milestones within the current project. If adding tasks to an existing milestone, use its name to identify it."

    constructor() {
        super(...arguments)
    }

    async _call(input) {
        const { projectId, milestones } = input

        const result = runCreateTasksAndMilestones(projectId, milestones)
        return result
    }
}

const tools = [new CreateTasksAndMilestonesTool()]


export const callAssistant = async ({
    query,
    currentProject,
    handleResponse
}) => {
    const prompt = ChatPromptTemplate.fromMessages([
        ["system", `You are a friendly & helpful built-in assistant for the project management app 'Hassl'. Within this app, users in an organisation can create projects (much like Monday/Asana/ClickUp). Within a project, tasks are grouped by 'milestone' (essentially a group of tasks). 

        Within milestones contain 'tasks'. These are the actual tasks required within each project. Tasks can have variable schemas - we'll tell you the task schema of each project when making a request, along with anything else you'd need to know. You'll be able to CRUD all tasks and milestones within a project using predefined functions.

        In order to be as helpful as possible, try to be as detailed as possible when creating projects. There are insights related to projects that you may be privy to that users themselves may or may not be aware of (or specify). You're an expert project manager - demonstrate your deep insight for the lifecycle of any kind of project, but don't be afraid to ask for clarification if you need more information. Detailed, realistics responses and actions is the goal here. 

        If your response includes a function call, you do not need to list all the same changes in the response. For example, if you create a series of tasks, you do not need to write "here are the additional tasks". The user will see them in their UI already. 

        When users ask things like "can you help flesh this out" or "can you help me with this", assume wherever possible they're asking for a function call - the ideal scenario is for their experience to be as little hands-on as possible.
        `],
        ["placeholder", "{chat_history}"],
        ["human", "{input}"],
        ["placeholder", "{agent_scratchpad}"],
    ]);

    if (!agent) {
        agent = await createToolCallingAgent({
            llm,
            tools,
            prompt,
        })
    }

    const agentExecutor = new AgentExecutor({
        agent,
        tools,
    })

    const baseProjectData = {
        id: currentProject.id,
        milestones: removeSoftDeleted(currentProject.milestones).map(milestone => {
            return {
                id: milestone.id,
                name: milestone.name,
                tasks: removeSoftDeleted(milestone.tasks).map(task => {
                    return {
                        id: task.id,
                        name: task.name
                    }
                })
            }
        })
    }

    const result = await agentExecutor.invoke({
        input: query,
        chat_history: [
            new SystemMessage(`The current project name is ${currentProject.name} and its ID is ${currentProject.id}. Not every query will require a function call - that's up to you. Existing project data is in the subsequent message.`),
            new SystemMessage(JSON.stringify(baseProjectData))
        ]
    })

    handleResponse(nl2br(result.output))
}